import axios from 'axios'
import moment from 'moment'

export default {
  methods: {
    /**
     * Gets count of active unique devices in array.
     * @param {array} visits - The array of device usage visits.
     * @return {integer} The count of the active unique devices.
     */
    getActiveDevicesCount (visits) {
      let deviceIds = []
      let deviceId = 0

      for (let i = 0; i < visits.length; i++) {
        deviceId = parseInt(visits[i].device_id, 10)

        if (!deviceIds.includes(deviceId)) {
          deviceIds.push(deviceId)
        }
      }

      return deviceIds.length
    },
    /**
     * Gets count of active unique users in array.
     * @param {array} visits - The array of device usage visits.
     * @return {integer} The count of the active unique users.
     */
    getActiveUsersCount (visits) {
      let userIds = []
      let userId = 0

      for (let i = 0; i < visits.length; i++) {
        userId = parseInt(visits[i].user_id, 10)

        if (!userIds.includes(userId)) {
          userIds.push(userId)
        }
      }

      return userIds.length
    },
    /**
     * Builds 1d array of device visitor count for line chart rendering.
     * @param {array} usage - The array of device usage visits.
     * @return {array} Array of device usage visit counts.
     */
    getDataFromUsage (usage) {
      let data = []

      for (let i = 0; i < usage.length; i++) {
        data.push(usage[i].visitors)
      }

      return data.reverse()
    },
    /**
     * Outputs array of objects of every date in given range.
     * @param {object} state - The store state object.
     * @return {array} Array of objects including visitor count at 0, the date, and the label which is the human-readable date.
     */
    getDatesInRange (state) {
      let dates = []
      let date = ''

      for (let i = 0; i < state.numDates; i++) {
        date = moment(state.endDate).subtract(i, 'days').format('YYYY-MM-DD')

        dates.push({
          visitors: 0,
          date,
          label: moment(date).format('MMM Do')
        })
      }

      return dates
    },
    /**
     * Queries data from the visits controller of the backend api with the parameters 'begin' and 'end' which represent
     * the beginning and end dates inclusively you want to get device visit data for.
     * @param {string} type - The type of device usage by user, device, or company.
     * @param {string} selection - The selection of whether to show all data or just data related to the admin's authentication level.
     */
    getDeviceUsage (type, selection = 'auth') {
      this.$store.commit('updateIsLoading', true)

      let self = this
      let begin = moment(this.$store.state.startDate).format('YYYY-MM-DD')
      let end = moment(this.$store.state.endDate).format('YYYY-MM-DD')
      let urlType = ''

      if (type === 'USER') {
        urlType = '/by_user/' + this.$route.params.id
      } else if (type === 'DEVICE') {
        urlType = '/by_device/' + this.$route.params.id
      } else if (type === 'COMPANY') {
        urlType = '/by_company/' + this.$route.params.id
      }

      axios.get(`${process.env.VUE_APP_API_URL}api/visits${urlType}?selection=${selection}&begin=${begin}&end=${end}`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let visits = response.data.data

          let dates = self.getDatesInRange(self.$store.state)
          let usageDates = self.getDeviceUsageDates(visits)
          let usage = self.getUsageByDate(usageDates, dates)
          let data = self.getDataFromUsage(usage)
          let labels = self.getLabelsFromUsage(usage)

          // add two dates if just one exists to account for chart
          if (self.$store.state.numDates === 1) {
            labels.push(labels[0])
            data.push(data[0])
          }

          self.deviceUsageNum = visits.length
          self.activeUsersNum = self.getActiveUsersCount(visits)
          self.activeDevicesNum = self.getActiveDevicesCount(visits)
          self.dateLabels = labels
          self.deviceUsage = data

          self.$store.commit('updateIsLoading', false)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /**
     * Converts all timestamps from device usage array to moment formatted dates.
     * @param {array} deviceUsage - The array of device usage visits.
     * @return {array} Array of objects of dates.
     */
    getDeviceUsageDates (deviceUsage) {
      let usageDates = []

      for (let i = 0; i < deviceUsage.length; i++) {
        usageDates.push({
          date: moment.utc(new Date(deviceUsage[i].time)).format('YYYY-MM-DD')
        })
      }

      return usageDates
    },
    /**
     * Builds a 1d array of date labels from the usage array to be rendered on the line chart.
     * @param {array} usage - The array of device usage visits.
     * @return {array} Array of labels in reverse order.
     */
    getLabelsFromUsage (usage) {
      let labels = []

      for (let i = 0; i < usage.length; i++) {
        labels.push(usage[i].label)
      }

      return labels.reverse()
    },
    /**
     * Gets device usage for every date and updates the visitors property on each object in the dates array.
     * @param {array} usageDates - The array of device usage dates.
     * @param {array} dates - The array of objects of dates in a range.
     * @return {array} The dates array with updated visitor properties.
     */
    getUsageByDate (usageDates, dates) {
      for (let i = 0; i < usageDates.length; i++) {
        for (let j = 0; j < dates.length; j++) {
          if (usageDates[i].date === dates[j].date) {
            dates[j].visitors += 1
          }
        }
      }

      return dates
    }
  }
}
